function extractEmail(pathname: string) {
    const atIndex = pathname.indexOf('@');
    let firstIndex = atIndex;
    let lastIndex = atIndex;
    while (pathname[firstIndex] != '/') {
        firstIndex++;
    }
    while (pathname[lastIndex] != '/') {
        lastIndex--;
    }
    const emailID = pathname.slice(lastIndex + 1, firstIndex);
    return emailID;
}

export default extractEmail;
